import {BroadcastButton} from "./ez-alpine-cmp-broadcast-button.js";
import {ProducerStudioPreviewToolbar} from "./ez-alpine-cmp-producerstudio-preview-toolbar.js";
import {LayoutSwitchButton, MediaDevicesButtons, ScreenshareButton} from "./ez-alpine-cmp-media-devices-buttons.js";
import {SessionStatus} from "./ez-alpine-cmp-session-status.js";
import {OnlineAttendeesLocView} from "./ez-alpine-cmp-online-attendees-loc-view";
import {TranscriptionPanel} from "./ez-alpine-cmp-transcription-panel";

window.EzAlpine = {
  BroadcastButton,
  ProducerStudioPreviewToolbar,
  MediaDevicesButtons,
  ScreenshareButton,
  LayoutSwitchButton,
  SessionStatus,
  OnlineAttendeesLocView,
  TranscriptionPanel,
  _version: '20260930113756',
};

const pdfjs_js = '/sites/all/modules/semineedle_custom/js/3rd/pdfjs-viewer-v2/pdfjs-viewer-element.min.js';
Toolbox.util.add_script_tag('pdfjs_js', pdfjs_js, true);
